import { render, staticRenderFns } from "./ReferralCodeSection.vue?vue&type=template&id=7c5c819c&scoped=true"
import script from "./ReferralCodeSection.vue?vue&type=script&lang=ts"
export * from "./ReferralCodeSection.vue?vue&type=script&lang=ts"
import style0 from "./ReferralCodeSection.vue?vue&type=style&index=0&id=7c5c819c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5c819c",
  null
  
)

export default component.exports